import { useEffect, useState } from "react";
import { useAbortController } from "./useAbortController";
import {
  IPaginacionApi,
  ITableDTO,
} from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import axios from "axios";
import { ITablaGruposDocumentos } from "../../../Interfaces/gestionDocumentos/IGrupoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import { IfilteApiDocumento } from "../../../Interfaces/gestionDocumentos/IDocumento";
export interface IItemLink {
  key: string;
  text: string;
  active: boolean;
}

export const useDocumentos = () => {
  const { handleAbortController } = useAbortController();
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<ITablaGruposDocumentos[]>([]);

  const [total, setTotal] = useState(0);
  const [nivel, setnivel] = useState(0);

  const [responseAPI, setresponseAPI] = useState<ITableDTO>();

  const [filter, setFilter] = useState<IfilteApiDocumento>({
    skip: 0,
    take: 50,
    search: "",
    parentId: "",
  });

  const postListaTabla = (filter: IfilteApiDocumento) => {
    setLoading(true);
    if (filter.parentId != "") {
      // getCountFiles(filter.parentId);

      // try {
      //   const res = await grupoDocumentoService.listarGrupos(
      //     filter,
      //     handleAbortController()
      //   );

      //   if (res.status == 200) {
      //     console.log(res.data);

      //     setItems(res?.data.items);
      //     setTotal(res?.data.total);
      //     setLoading(false);
      //   }
      // } catch (e) {
      //   if (axios.isCancel(e)) {
      //     console.log("Solicitud cancelada:", e);
      //   } else {
      //     console.error("Error en la solicitud:", e);
      //     setLoading(false);
      //   }
      // }

      grupoDocumentoService
        .listarGrupos(filter, handleAbortController())
        .then((res) => {
          if (res.status == 200) {
            setresponseAPI(res.data);
            setItems(res?.data?.items);
            setTotal(res?.data?.total);
            setLoading(false);
          }
        })

        .catch((e) => {
          if (axios.isCancel(e)) {
            
          } else {
            console.error("Error en la solicitud:", e?.message);
            setLoading(false);
          }
        });
    }
  };

  const getNivel = (parentId: string) => {
    grupoDocumentoService
      .getCountFiles(parentId)
      .then((res) => {
        if (res.status == 200) {
          setnivel(res?.data?.nivel);
        }
      })

      .catch((e) => {
        if (axios.isCancel(e)) {
         
        } else {
          console.error("Error en la solicitud:", e?.message);
          setLoading(false);
        }
      });
  };

  const limpiarFiltro = (parentId: string) => {
    setFilter({ ...filter, skip: 0, take: 50, search: "", parentId: parentId });
  };

  const onChangeTake = (take: number) => {
    setFilter({ ...filter, take: take });
  };

  const onChangeSkip = (skip: number) => {
    setFilter({ ...filter, skip: skip });
  };

  const onChangeTextSearch = (
    ev?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue != undefined) {
      setFilter({ ...filter, search: newValue });
      if (newValue.length == 0) {
        _onClearSearch();
      }
    }
  };

  const _onClearSearch = () => {
    setFilter({
      ...filter,
      search: "",
    });
  };

  const paginacionTable: IPaginacionApi = {
    onChangeTake: onChangeTake,
    onChangeSkip: onChangeSkip,
    totalPagesPagination: Number.parseInt(responseAPI?.pages!),
    skipPagination: filter.skip,
    takePagination: filter.take,
    isVisible: true,
    isLoading: loading,
    total: items ? Number.parseInt(responseAPI?.total!) : 0,
  };

  useEffect(() => {
    postListaTabla(filter);
  }, [filter]);

  useEffect(() => {
    if (filter.parentId != "") {
      getNivel(filter.parentId);
    }
  }, [filter.parentId]);

  return {
    items,
    loading,
    filter,
    setFilter,
    limpiarFiltro,
    total,
    postListaTabla,
    paginacionTable,
    onChangeTextSearch,
    nivel,
  };
};
